import React from 'react'

const ClubPoints = () => {
  return (
    <div>Club Points Earned till now</div>
  )
}

export default ClubPoints